<div class="nf-panel zcs">
    <div class="nf-panel__header">
        <div class="nf-panel__icon" [class.nf-panel__icon--success]="succeeded" [class.nf-panel__icon--error]="failed" aria-hidden="true">
            @if (failed) {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 3 4.5 6v5.5c0 4.6 3.2 8.6 7.5 9.5 4.3-.9 7.5-4.9 7.5-9.5V6L12 3Z" />
                <path d="m9.5 9.5 5 5M14.5 9.5l-5 5" />
            </svg>
            } @else if (succeeded) {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 3 4.5 6v5.5c0 4.6 3.2 8.6 7.5 9.5 4.3-.9 7.5-4.9 7.5-9.5V6L12 3Z" />
                <path d="m8.75 12 2.25 2.25 4.25-4.5" />
            </svg>
            } @else {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 3 4.5 6v5.5c0 4.6 3.2 8.6 7.5 9.5 4.3-.9 7.5-4.9 7.5-9.5V6L12 3Z" />
                <rect x="9" y="11" width="6" height="4.5" rx="1" />
                <path d="M10.25 11V9.75a1.75 1.75 0 0 1 3.5 0V11" />
            </svg>
            }
        </div>
        <div class="nf-panel__heading">
            <h2 class="nf-panel__title" [id]="titleId">Establishing secure connection</h2>
            <p class="nf-panel__subtitle" aria-live="polite">{{ subtitle }}</p>
        </div>
    </div>

    <div class="nf-panel__body">
        <ol class="zcs-steps">
            @for (step of steps; track $index) {
            <li class="zcs-step" [class.is-active]="step.status === 'active'" [class.is-error]="step.status === 'error'">
                <span class="zcs-step__icon" aria-hidden="true">
                    @if (step.status === 'success') {
                    <svg viewBox="0 0 20 20" class="zcs-icon zcs-icon--success">
                        <circle cx="10" cy="10" r="9" />
                        <path d="m6.25 10.25 2.5 2.5 5-5.25" fill="none" />
                    </svg>
                    } @else if (step.status === 'error') {
                    <svg viewBox="0 0 20 20" class="zcs-icon zcs-icon--error">
                        <circle cx="10" cy="10" r="9" />
                        <path d="m7 7 6 6M13 7l-6 6" fill="none" />
                    </svg>
                    } @else if (step.status === 'active') {
                    <svg viewBox="0 0 20 20" class="zcs-icon zcs-icon--active">
                        <circle class="zcs-icon__track" cx="10" cy="10" r="8" />
                        <circle class="zcs-icon__arc" cx="10" cy="10" r="8" />
                    </svg>
                    } @else {
                    <svg viewBox="0 0 20 20" class="zcs-icon zcs-icon--pending">
                        <circle cx="10" cy="10" r="8" />
                    </svg>
                    }
                </span>
                <span class="zcs-step__text">
                    <span class="zcs-step__label">{{ step.label }}</span>
                    @if (step.status === 'active' && step.progress !== undefined) {
                    <span class="zcs-step__progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="step.progress">
                        <span class="zcs-step__progress-bar" [style.width.%]="step.progress"></span>
                    </span>
                    }
                    @if (step.status === 'active' && step.detail) {
                    <span class="zcs-step__detail">{{ step.detail }}</span>
                    }
                </span>
                <span class="zcs-step__state">{{ stateLabel[step.status] }}</span>
            </li>
            }
        </ol>
    </div>

    @if (!finished) {
    <div class="nf-panel__actions">
        <button type="button" class="nf-btn" (click)="cancel()" id="ZitiConnectionCancel">Cancel</button>
    </div>
    } @else if (failed) {
    <div class="nf-panel__actions">
        <button type="button" class="nf-btn" (click)="close()" id="ZitiConnectionClose">Close</button>
        <button type="button" class="nf-btn nf-btn--primary" (click)="retry()" id="ZitiConnectionRetry">Retry</button>
    </div>
    }
</div>
